module.exports = __webpack_public_path__ + "img/agricultura.78b8152f.svg";